import { useRef } from 'react';

// Blob preview URLs per kind, revoked on replace and release so picked files are freed.
// Not revoked on unmount: the form outlives this hook (e.g. across editor tabs) and still shows them.
export const useKindObjectUrls = <Kind extends string>() => {
  const urls = useRef<Partial<Record<Kind, string>>>({});

  const release = (kind: Kind) => {
    const url = urls.current[kind];
    if (url) URL.revokeObjectURL(url);
    delete urls.current[kind];
  };

  const create = (kind: Kind, file: File) => {
    release(kind);
    const url = URL.createObjectURL(file);
    urls.current[kind] = url;
    return url;
  };

  return { create, release };
};
